import {Campaign, CampaignsFilter, CampaignUserStatus, SortOptions} from "shared-lib";
import {patchState, signalStore, watchState, withHooks, withMethods, withState} from '@ngrx/signals';
import {inject} from "@angular/core";
import {CampaignsFilterStore} from './campaigns-filter.store';
import {Observable} from "rxjs";
import {CampaignService} from '../services/campaign.service';

interface CampaignsState {
  campaigns: Campaign[];
  isLoading: boolean;
  status: CampaignUserStatus;
  filter: CampaignsFilter;
}

const initialState = {
  campaigns: [],
  isLoading: false,
  filter: {
    sort: SortOptions.MOST_RECENT,
  } as CampaignsFilter
};

type AllCampaignsFetcher = (
  service: CampaignService,
  filter: CampaignsFilter
) => Observable<Campaign[]>;

function createCampaignsStore(status: CampaignUserStatus, fetcher: AllCampaignsFetcher) {
  return signalStore(
    {providedIn: 'root'},
    withState({...initialState, status} as CampaignsState),
    withMethods((store, campaignService = inject(CampaignService)) => ({
      loadData() {
        patchState(store, {isLoading: true});
        fetcher(campaignService, store.filter()).subscribe(campaigns => {
          patchState(store, {
            campaigns: [...campaigns],
            isLoading: false,
          });
        });
      }
    })),
    withHooks({
      onInit(store, filterStore = inject(CampaignsFilterStore)) {
        watchState(filterStore, (state) => {
          const filterValue = state.filter;

          if (filterValue === store.filter()) {
            return;
          }

          patchState(store, {filter: filterValue});
          if(filterValue.geoBounds) {
            store.loadData();
          }
        });
      }
    })
  );
}

export const LocationsWithLoyaltyStore = createCampaignsStore(
  CampaignUserStatus.ACTIVE,
  (service, filter) => service.getAllCampaignsWithLoyalty(filter)
);

export const LocationsWithoutLoyaltyStore = createCampaignsStore(
  CampaignUserStatus.REDEEMED,
  (service, filter) => service.getAllCampaignsWithoutLoyalty(filter)
);

export type MyPlacesMapStore =
  | InstanceType<typeof LocationsWithLoyaltyStore>
  | InstanceType<typeof LocationsWithoutLoyaltyStore>;

